import { Ortak } from './../../../providers/ortak';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController, ActionSheetController } from 'ionic-angular';
import { flatten } from '@angular/compiler';


@Component({
  selector: 'page-stok-hareketleri',
  templateUrl: 'stok-hareketleri.html',
})
export class StokHareketleriPage {
  stok: any = { ID: "" };
  hareketlistesi = [];
  constructor(public navCtrl: NavController,
    public bllOrtak: BllOrtak,
    public actionSheetCtrl:ActionSheetController,
    public viewCtrl:ViewController,
    public ortak:Ortak,
    public navParams: NavParams) {
    if (navParams.get("stok") != null) {
      this.stok = navParams.get("stok");
      var formdata = new FormData();
      formdata.append("stokid", this.stok.ID);

      console.log("stk",this.stok.ID)
      this.bllOrtak.islem(formdata, "StokHareketleri", "", false).then(a => {
        var sonuc = <any>a;
        this.hareketlistesi = sonuc.SonucObject;
       
      console.log("harhar",this.hareketlistesi)
      })
    }
  }
kapat()
{
  this.viewCtrl.dismiss();
}
Cikart() {
  var data = [];
  this.hareketlistesi.forEach(rapor => {
    data.push({
   
       
      "Cari ADI": rapor.Definition_,
      "Slsman":rapor.SlsMan,
        "IslemTarihi":rapor.StokHareketIslemTarihi,
      "BirimFiyat":rapor.BirimFiyat,
      "Miktar":rapor.Miktar,
      "Tutar":rapor.Tutar,
      
    })
  
  });
  this.ortak.ExportExcel(data, "Hareketler - ").then(a => {
  }).catch(x => {
  });
}

HareketSil(st) {
  this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
    var formData = new FormData();
    
    formData.append("ID", st.ID);
console.log("adsadas", st);
    this.bllOrtak.islem(formData, "HareketSilStok", "", true).then(a => {
     
      this.viewCtrl.dismiss();

       
    }).catch(x => {

      this.ortak.showErrorAlert();
    })
    
  })
  
}

Islemler(st) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Stok Hareket İşlemleri',
    buttons: [
     {
        text: 'Sil',
        handler: () => {
         this.HareketSil(st);
        }
      },
      {
        text: 'İptal ',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
  });
  actionSheet.present();
}

}



// WEBPACK FOOTER //
// ./src/pages/StokIslemleri/stok-hareketleri/stok-hareketleri.ts